import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import Title from '../Common/Title';
import { useTranslation } from 'react-i18next';
import { useFaqs } from '../../services/faq/queryFaq';

export default function Faqs() {
  const { t, i18n } = useTranslation();
  const lang = i18n?.language || 'es';

  const { data: fetchedFaqs = [], isLoading, isError, refetch } = useFaqs(lang);
  const faqs = fetchedFaqs || [];

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 pb-12 sm:pb-56 pt-12 lg:px-8 ">
        <div className="mx-auto max-w-4xl">
          <Title title={t('faqs.title')} align="left" color />
          {isError && (
            <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
              {t('faqs.error')}
              <button
                type="button"
                className="ml-3 inline-flex items-center rounded-md border border-red-300 px-2 py-1 text-xs font-medium text-red-800 hover:bg-red-100"
                onClick={refetch}
              >
                {t('faqs.retry')}
              </button>
            </div>
          )}
          {isLoading && (
            <div className="mt-6 text-sm text-gray-500">{t('faqs.loading')}</div>
          )}
          <dl className="mt-10 space-y-6">
            {faqs.map((faq, index) => (
              <Disclosure as="div" key={`faq-${index}`} className="pl-10 pr-4 py-4 rounded-xl border-primary/10 border-[1px]">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-center sm:items-start justify-between text-left text-black">
                        <span className="text-[18px] sm:text-xl font-semibold sm:leading-7 text-[#232323]">
                          {faq.question}
                        </span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <ChevronUpIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          ) : (
                            <ChevronDownIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <div
                        className="prose prose-sm text-base leading-7 text-[#363538] prose-li:ml-6 prose-ul:pl-6 prose-ul:list-disc prose-ol:list-decimal"
                        dangerouslySetInnerHTML={{ __html: faq.answerHtml || '' }}
                      />
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
